import React from 'react';
import { Button, ButtonGroup } from '@mui/material';

const Navigation = ({ hasRatings, hasCaseStudies, hasCustomerJourney, hasReviews, hasBullets }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', paddingLeft: (!isMobile && !hasBullets) ? 224 : 0 }}>
      <ButtonGroup
        variant="text"
        style={{ minWidth: isMobile ? 'unset' : 'auto', flexWrap: 'nowrap' }}
      >
        <Button sx={{ px: '30px', py: '10px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('about')}>Overview</Button>
        {hasReviews && (
          <Button sx={{ px: '30px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('reviews')}>Reviews</Button>
        )}
        {hasRatings && (
          <Button sx={{ px: '30px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('ratings-reviews')}>Ratings & Reviews</Button>
        )}
        <Button sx={{ px: '30px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('technology')}>Hardware</Button>
        {hasCustomerJourney && (
          <Button sx={{ px: '30px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('customer-journey')}>Customer Journey</Button>
        )}
        {hasCaseStudies && (
          <Button sx={{ px: '30px', whiteSpace: 'nowrap' }} onClick={() => handleScroll('case-studies')}>Case Studies</Button>
        )}
      </ButtonGroup>
    </div>
  );
};

export default Navigation;
